import React from 'react';
import classNames from 'classnames';
import SelectFieldCustom, {
  ItemType,
  Props as SelectFieldCustomProps,
} from 'components/Common/FieldCustom/SelectFieldCustom/SelectFieldCustom';
import Loader from 'components/Common/Loader/Loader';

import styles from './ProductSelectSize.module.scss';

type Props = {
  items: ItemType[];
  size?: string;
  setSize: (size: string) => void;
  placeholder: string;
  showLoader?: boolean;
  onSelectOpen?: () => void;
  classes?: SelectFieldCustomProps['classes'];
  SelectRenderComponent?: SelectFieldCustomProps['RenderComponent'];
  SelectRenderCustomProps?: Record<string, unknown>;
};

/**
 * Product page of website. Contains details product data.
 */
export default function ProductSelectSize({
  items,
  size,
  setSize,
  placeholder,
  showLoader = false,
  onSelectOpen,
  classes,
  SelectRenderComponent,
  SelectRenderCustomProps,
}: Props): JSX.Element {
  const { menuList, ...baseClasses } = classes || {};
  const renderLoader = () => {
    return (
      <div className={styles['loader-wrapper']}>
        <Loader className={styles.loader} />
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {showLoader && renderLoader()}
      <SelectFieldCustom
        data={size}
        setData={setSize}
        items={items}
        placeholder={placeholder}
        classes={{
          menuList: classNames(styles.menuList, menuList),
          ...baseClasses,
        }}
        disabled={showLoader}
        onSelectOpen={onSelectOpen}
        RenderComponent={SelectRenderComponent}
        {...SelectRenderCustomProps}
      />
    </div>
  );
}
